    function showSection(tabNumber) {
        // Hide all tabs
        document.querySelectorAll('.show-tab-1, .show-tab-2, .show-tab-3').forEach(tab => {
            tab.style.display = 'none';
        });

        // Show the selected tab
        document.querySelector(`.show-tab-${tabNumber}`).style.display = 'block';
    }